import { __decorate } from "tslib";
import { Component, ViewEncapsulation } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { WebsiteThemeService } from '../../../../services/website-theme.service';
/**
 * End Component
 */
let EndShopComponent = class EndShopComponent {
    constructor(sanitizer, themeService) {
        this.sanitizer = sanitizer;
        this.themeService = themeService;
        this.item = {};
        this.textColor = '';
        this.item = JSON.parse(localStorage.getItem('paymentData'));
        this.themeService.getTheme().subscribe((data) => {
            this.textColor = this.themeService.getStyleAttribute('text_color');
        });
    }
    ngOnInit() {
        localStorage.removeItem('products');
    }
};
EndShopComponent.ctorParameters = () => [
    { type: DomSanitizer },
    { type: WebsiteThemeService }
];
EndShopComponent = __decorate([
    Component({
        selector: 'ecd-shop-end',
        encapsulation: ViewEncapsulation.None,
        template: __importDefault(require("./end.component.html")).default
    })
], EndShopComponent);
export { EndShopComponent };
